const RECENTS_KEY = "si_recent_repos_v1";

export function loadRecents() {
  try {
    const raw = localStorage.getItem(RECENTS_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function saveRecents(keys) {
  try {
    localStorage.setItem(RECENTS_KEY, JSON.stringify(keys.slice(0, 12)));
  } catch {}
}

export function markRecentStorage(repoKey) {
  if (!repoKey) return;
  const cur = loadRecents();
  const next = [repoKey, ...cur.filter((x) => x !== repoKey)];
  saveRecents(next);
}

export async function fetchIndex() {
  const urls = [
    "/projects/index.json",
    "/jekyll/projects/index.json",
    "/projects/index.json?ts=" + Date.now(),
    "/jekyll/projects/index.json?ts=" + Date.now(),
  ];

  for (const u of urls) {
    try {
      const res = await fetch(u, { cache: "no-store" });
      if (!res.ok) continue;
      const json = await res.json();
      if (Array.isArray(json)) return json;
    } catch {}
  }

  return [];
}

export function fileLabelFromPath(p) {
  const s = String(p || "");
  const last = s.split("/").pop() || s;
  return last.replace(/\.(md|markdown|mdown)$/i, "") || "Document";
}
